export default __webpack_public_path__ + "static/media/swf.163ec45c.svg";